export const sidebarUser = theme => ({})
